import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

/** Resend registration verification email. Does not require password. */
export async function resendRegistrationVerificationEmail({
  email,
  practiceName = '',
  baseUrl = typeof window !== 'undefined' ? window.location.origin : '',
  returnTo = '',
  intent = '',
} = {}) {
  const trimmed = String(email || '')
    .trim()
    .toLowerCase();
  if (!trimmed) {
    throw new Error('Email is required to resend verification.');
  }

  const sendVerification = httpsCallable(functions, 'sendRegistrationVerificationEmail');
  await sendVerification({
    email: trimmed,
    practiceName: String(practiceName || '').trim(),
    baseUrl: baseUrl || 'https://smileconsent.co.uk',
    ...(returnTo ? { returnTo: String(returnTo) } : {}),
    ...(intent ? { intent: String(intent) } : {}),
  });
}
